<template>
  <div>
    <v-card-title class="student-detail">
      <div class="cadr">
        <div>
          <div class="avatar" :style="{ 'background-image': ImageUrl }"></div>
          <div class="summary">
            {{ student.StudentName }}
            <br />
            {{ Num_System }}
          </div>
        </div>
        <div class="states">
          <v-radio-group
            :key="componentKey"
            v-model="currentState"
            row
            @change="onChangeState($event)"
            :active-class="activeClass"
            hide-details
          >
            <v-radio label="حاضر" :value="-1"></v-radio>
            <v-radio label="غایب" :value="2"></v-radio>
            <v-radio label="تاخیر" :value="0"></v-radio>
          </v-radio-group>
        </div>
      </div>
    </v-card-title>
  </div>
</template>

<script>
export default {
  props: ["student"],
  data() {
    return {
      changedState: false,
      componentKey: 0,
      currentState: this.student.State,
    };
  },
  computed: {
    ImageUrl() {
      if (this.student.ImageUrl != "") {
        return "url(" + this.student.ImageUrl + ")";
      } else return "../../assets/avatar.jpg";
    },
    Num_System() {
      return parseInt(this.student.Num_System);
    },
    activeClass() {
      return this.changedState ? "active-customized" : "v-item--active";
    },
  },

  methods: {
    onChangeState($event) {
      this.componentKey++;
      this.changedState = this.student.State != $event;
      this.$emit("changed", this.student.State, $event, this.student.LesRegID);
    },
  },
};
</script>
<style scoped>
.avatar {
  width: 72px;
  height: 72px;
  float: right;
  margin: 10px 15px 0px;
  border-radius: 50px;
  background-size: 100% 100%;
}
.cadr {
  background-color: white;
  width: 100%;
  border-radius: 10px;
}
.v-card__title {
  padding: 3px !important;
}

.summary {
  top: 20px;
  position: relative;
  color: black;
}
.states {
  padding: 0 0px;
}
.v-input {
  width: 100%;
  margin: 0 !important;
  padding: 8px 4px !important;
}
.v-radio {
  margin: 6px !important;
  padding: 5px;
  border: 1px solid black;
  border-radius: 10px;
  width: calc(33.333% - 12px);
  background-color: white;
  direction: ltr;
}

.v-card__title {
  border-radius: 15px !important;
}
</style>
<style lang="scss" scoped>
.active-customized {
  @extend .v-item--active !optional;
  background-color: cyan;
}
</style>
